import React from "react";

export const Visa = () => {
  return (
    <svg
      role="img"
      aria-label="Visa logo"
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="32"
      viewBox="0 0 61 32"
      fill="none"
    >
      <rect width="60.8" height="32" rx="6.4" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1462 10.1389L38.699 12.7944C37.3582 12.0352 34.3066 11.8556 34.3063 13.2538C34.3063 13.8093 34.9967 14.1913 35.8289 14.6517C37.091 15.35 38.6791 16.2286 38.6791 18.1661C38.6791 21.2622 35.4533 22.3997 33.3151 22.3997C31.1774 22.3997 29.7783 21.7015 29.7783 21.7015L30.2442 18.9249C31.5271 19.9831 35.4144 20.2838 35.4144 18.6057C35.4144 17.9006 34.6491 17.4848 33.7618 17.0026C32.5374 16.3373 31.0805 15.5456 31.0805 13.6934C31.0805 10.298 34.7731 9.59973 36.328 9.59973C37.7664 9.59973 39.1462 10.1389 39.1462 10.1389ZM22.0776 9.82004L19.0904 18.3253L18.7369 16.4938L18.7373 16.4944L17.6829 10.9334C17.6829 10.9334 17.5554 9.82004 16.1966 9.82004H11.2581L11.2002 10.0294C11.2002 10.0294 12.7104 10.3523 14.4778 11.4428L17.2 22.1861H20.4647L25.4499 9.82004H22.0776ZM27.8461 22.1857H24.7127L26.671 9.82004H29.8047L27.8461 22.1857ZM49.6002 22.1861H46.7231L46.3561 20.3493H42.3728L41.7196 22.1861H38.4533L43.1265 10.7416C43.1265 10.7416 43.4098 9.82004 44.5729 9.82004H47.0917L49.6002 22.1861ZM43.2752 17.8117L44.9216 13.1841L45.8478 17.8117H43.2752Z"
        fill="#2566AF"
      />
      <path
        d="M18.7373 16.4349L17.6829 10.9222C17.6829 10.9222 17.5554 9.81848 16.1966 9.81848H11.2581L11.2002 10.026C11.2002 10.026 13.5738 10.5271 15.8505 12.4043C18.0274 14.1986 18.7373 16.4349 18.7373 16.4349Z"
        fill="#E6A540"
      />
    </svg>
  );
};
